import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={48}
        height={48}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={24} cy={24} r={24} fill="#B1D966" />
        <g clipPath="url(#clip0_653_1244)">
            <path
                d="M12.75 35.25H35.25M29.931 35.25H18.069L16.527 28.281C16.4931 28.1299 16.4904 27.9735 16.5189 27.8214C16.5475 27.6692 16.6067 27.5245 16.693 27.396C16.7713 27.2756 16.8778 27.1763 17.0033 27.1065C17.1288 27.0368 17.2695 26.9989 17.413 26.996H30.587C30.7305 26.9989 30.8712 27.0368 30.9967 27.1065C31.1222 27.1763 31.2287 27.2756 31.307 27.396C31.3933 27.5245 31.4525 27.6692 31.4811 27.8214C31.5096 27.9735 31.5069 28.1299 31.473 28.281L29.931 35.25Z"
                stroke="white"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.4453 14.78C21.0842 15.4425 21.85 15.9695 22.697 16.3294C23.5441 16.6894 24.455 16.8749 25.3753 16.875C26.3083 16.875 27.2313 16.685 28.0883 16.317M22.5003 30.75C22.5003 31.1479 22.6583 31.5294 22.9397 31.8107C23.221 32.092 23.6025 32.25 24.0003 32.25C24.3981 32.25 24.7797 32.092 25.061 31.8107C25.3423 31.5294 25.5003 31.1479 25.5003 30.75C25.5003 30.3522 25.3423 29.9707 25.061 29.6894C24.7797 29.4081 24.3981 29.25 24.0003 29.25C23.6025 29.25 23.221 29.4081 22.9397 29.6894C22.6583 29.9707 22.5003 30.3522 22.5003 30.75Z"
                stroke="white"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29 24.75C28.3737 24.0418 27.604 23.4748 26.742 23.0864C25.8801 22.698 24.9454 22.4972 24 22.4972C23.0546 22.4972 22.1199 22.698 21.258 23.0864C20.396 23.4748 19.6263 24.0418 19 24.75M19.875 16.875C19.875 17.969 20.3096 19.0182 21.0832 19.7918C21.8568 20.5654 22.906 21 24 21C25.094 21 26.1432 20.5654 26.9168 19.7918C27.6904 19.0182 28.125 17.969 28.125 16.875C28.125 15.781 27.6904 14.7318 26.9168 13.9582C26.1432 13.1846 25.094 12.75 24 12.75C22.906 12.75 21.8568 13.1846 21.0832 13.9582C20.3096 14.7318 19.875 15.781 19.875 16.875Z"
                stroke="white"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_653_1244">
                <rect
                    width={24}
                    height={24}
                    fill="white"
                    transform="translate(12 12)"
                />
            </clipPath>
        </defs>
    </svg>
);

const Usericon = React.memo(SVGComponent)
export default Usericon;
